import styled from "styled-components/macro";

export const EventsSectionContainer = styled.div`
  z-index: 100;
  display: block;
  justify-content: center;
  align-items: center;
`;

export const EventsContainer = styled.div`
  display: grid;
`;
